// Reemplazo local de "vue-filter-date-parse" (despublicado de npm en 2021).
// Registra el filtro `dateParse(format?)`: convierte un string en Date para
// encadenarlo con `dateFormat`. Sin formato se parsea como ISO en hora local.
import moment from "moment";

export default {
  install(Vue) {
    Vue.filter("dateParse", (value, format) => {
      if (value === null || value === undefined || value === "") return value;
      if (value instanceof Date) return value;
      return (format ? moment(value, format) : moment(value)).toDate();
    });
  },
};
